import React from 'react'
import { Vendor } from '../../lib/types/Vendor'
import dayjs from 'dayjs'
import { ReactComponent as ActionDelete } from '../../images/icons/action_delete.svg'
import { ReactComponent as ActionEdit } from '../../images/icons/action_edit.svg'
import { getImageURL } from '../../lib/utils/getImageURL'
import { useNavigate } from 'react-router'

type Props = {
  vendor: Vendor
}

export default function ConnectedVendorAccount({ vendor }: Props): JSX.Element {
  const navigate = useNavigate()

  return (
    <div className="grid grid-cols-4 items-center py-5 font-Spartan">
      <div className="flex flex-row gap-2 items-center justify-start">
        {vendor?.logo ? (
          <img
            src={getImageURL(`images/vendors/${vendor.logo}`)}
            className="h-10 w-10 object-contain"
          />
        ) : (
          <></>
        )}
        <span className="font-bold text-lg">{vendor.name}</span>
      </div>
      <span className="text-sm font-semibold">{vendor.connectionDetails?.user_name}</span>
      <span className="text-sm font-semibold">
        {dayjs(vendor.connectionDetails?.created_date).format('MMM DD, YYYY')}
      </span>
      <div className="flex flex-row items-center justify-start gap-2">
        <ActionEdit
          className="stroke-primary-persian-blue w-5 h-5 cursor-pointer"
          onClick={(e) => {
            e.preventDefault()
            navigate(`./${vendor.id}/edit`)
          }}
        />
        <ActionDelete
          className="w-6 h-6 cursor-pointer"
          onClick={(e) => {
            e.preventDefault()
            navigate(`./${vendor.id}/delete`)
          }}
        />
      </div>
    </div>
  )
}
